// extracted by mini-css-extract-plugin
module.exports = {"root":"CategoryService_root__3hTnz","label":"CategoryService_label__17d4j","location":"CategoryService_location__1esRA"};